import script from "./LogoutView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogoutView.vue?vue&type=script&lang=ts&setup=true"

import "./LogoutView.vue?vue&type=style&index=0&id=352c4726&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352c4726"]])

export default __exports__